// Adds small prev/next arrows to the product gallery so shoppers know they can swipe.
(function () {
  var chevron = function (d) {
    return '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="' + d + '"/></svg>';
  };

  function attach(list) {
    var swiper = list.swiper;
    if (!swiper || list.querySelector('.vampstr-gal-arrow')) return;
    if (swiper.slides.length < 2) return;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'vampstr-gal-arrow vampstr-gal-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = chevron('M10 3 5 8l5 5');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'vampstr-gal-arrow vampstr-gal-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = chevron('M6 3l5 5-5 5');

    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); swiper.slidePrev(); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); swiper.slideNext(); });

    var sync = function () {
      prev.disabled = swiper.isBeginning;
      next.disabled = swiper.isEnd;
    };
    swiper.on('slideChange', sync);
    sync();

    list.appendChild(prev);
    list.appendChild(next);
  }

  function init() {
    var tries = 0;
    var timer = setInterval(function () {
      var lists = document.querySelectorAll('.product__media-wrapper .js-media-list');
      lists.forEach(attach);
      var ready = Array.prototype.every.call(lists, function (l) { return l.swiper; });
      if ((lists.length && ready) || ++tries > 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
